import React from "react";
import styles from "./styles.css";
import PropTypes from "prop-types";

const getStarIcon = (text = "") => {
    return text.split("*").map((item, index) => (
        <React.Fragment key={index}>
            {item}
            {index !== text.split("*").length - 1 && <span styleName="styles.star">*</span>}
        </React.Fragment>
    ));
};

const BestInAustralia = ({ specificationsDetail }) => {
    const { specifications = [] } = specificationsDetail || {};
    if (!specifications?.length) {
        return null;
    }

    return (
        <div styleName={"styles.outer"}>
            <div styleName={"styles.contentWrapper"}>
                <p styleName={"styles.heading"}>Best in Australia</p>
                <p styleName={"styles.subHeading"}>Choice of 5,000+ users.</p>
            </div>

            {specifications.map((item, index) => (
                <div styleName={"styles.itemCardWrapper"} key={index}>
                    <div styleName={"styles.itemCard"}>
                        <p styleName={"styles.heading"}>{getStarIcon(item?.info?.replaceAll("**", ""))}</p>
                        <p styleName={"styles.subHeading"}>{item.description}</p>
                    </div>
                    <img src={item.iconUrl} alt={item.heading} />
                </div>
            ))}
        </div>
    );
};

BestInAustralia.propTypes = {
    specificationsDetail: PropTypes.object
};

export default BestInAustralia;
